<!--设备状态（环形图，柱状图）-->
<template>
<div class="devicestatus commonborder flex_row">
  <div class="num">总设备：<b>{{totalDev}}</b>台</div>
  <div id="devicestatus_pie1" class="echarts"></div>
  <!-- <div id="devicestatus_bar1" class="echarts"></div> -->
</div>

</template>

<script>
import api from '@/apis/device/device'
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      totalDev:'',
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getState().then(res=>{
        if(res.code==10000){
          let _data = res.data[0]
          // let _arr = [
          //   _data.useDevNum,
          //   _data.idleDevNum,
          //   _data.notHireDevNum,
          //   _data.hireDevNum,
          //   _data.saleDevNum,
          // ]
          this.devicestatus_pie1(
            _data.highDevNum,
            _data.normalDevNum,
            _data.lowDevNum,
            _data.haulDevNum,
            _data.tfDevNum	,
          )
          // this.devicestatus_bar1(_arr)
          this.totalDev = _data.totalDevNum
        }
      })
    },
    devicestatus_pie1(a1,a2,a3,a4,a5){
      let devicestatus_pie1 = echarts.init( document.getElementById('devicestatus_pie1') );
      devicestatus_pie1.setOption({
          color:['#00ccff','#1ad38b','#fc5976','#ae74f3','#f4af1b'],
          tooltip: {
            trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
            formatter:'{b}<br />{c} 台',
          },
          legend: {
            show:false
          },
          series: [
            {
              // name: '访问来源',
              type: 'pie',
              radius: ['30%', '40%'],
              center:['50%','40%'],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 4,
                borderColor: '#081693',
                borderWidth: 2
              },
              label: {
                show: true,color:'#ccd0f2',fontSize:this.$echartsFontSize,
                formatter: '{b}\n{num|{d}%}', lineHeight:this.$echartsFontSize+4,
                rich: {
                  num: {
                    color: '#fff',fontSize:this.$echartsFontSize
                  }
                }
              },
              data: [
                {value: a1, name: '高速运转'},
                {value: a2, name: '正常运转'},
                {value: a3, name: '低速运转'},
                {value: a4, name: '检修状态'},
                {value: a5, name: '关机状态'}
              ]
            }
          ] 
      })
      this.$common.moveEcharts(5,devicestatus_pie1);
    },
    devicestatus_bar1(arr){
      let devicestatus_bar1 = echarts.init( document.getElementById('devicestatus_bar1') );
      devicestatus_bar1.setOption({
          color:['#ffea04','#00ccff','#1ad38b','#fc5976','#ae74f3','#f4af1b'],
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},},
          xAxis: {
              type: 'category',
              axisLabel:{color:'#fff',rotate:25,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:'#0060a7'}},
              data: ['使用中', '闲置中', '待出租', '已出租', '待出售']
          },
          yAxis: {
              axisLabel:{color:'#ccd0f2',fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:'#0060a7'}},splitNumber:3,
              splitLine:{lineStyle:{color:'#2336ba'}}
          },
          grid: { left: '50px',right:'15px',top:'30px',bottom:'60px'},
          series: [
              {
                type: 'bar',
                barWidth:'20%',
                data: arr,
                label: {
                    show: true,
                    position: 'top',
                    textStyle:{ color:'#fff',fontSize:this.$echartsFontSize}
                },
              } 
          ]
      })
    },
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.devicestatus{
  #devicestatus_pie1{ height: 100%; width: 48%;}
  #devicestatus_bar1{ height: 100%; width: 52%;}
  .num{ font-size: 1rem; color: #7fffff; position: absolute; z-index: 9; bottom: 1rem; left: 0; width: 100%; text-align: center;
    b{ font-family: 'DS-DIGI'; font-size: 1.6rem; font-weight: 400;}
  }
}
</style>